// Calendar dates in the user's own time zone. Date#toISOString() is UTC, so
// "today" built from it is already tomorrow in the US evening (and a local
// midnight becomes the previous day east of UTC). Use these for every
// date default and date-only comparison in the UI. (2026-09-30)
export function localDateStr(d = new Date()) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

// 'YYYY-MM-DD' + n calendar days -> 'YYYY-MM-DD', with no time-zone drift.
export function addDaysStr(ymd, n) {
  const [y, m, d] = ymd.split('-').map(Number);
  return localDateStr(new Date(y, m - 1, d + n));
}